angular.module('wbDashboard')
.controller('MilestoneModRetirementController', ['$scope', 'PlanService', '$uibModal', 'Message',
function ($scope, PlanService, $uibModal, Message) {
    //simple pages: ['amount', 'age', 'life', 'ss-payout', 'ss-age']

    $scope.mod || ($scope.mod = {extra:{}}); // jshint ignore:line

    if ($scope.mod.action) {
        if ($scope.mod.action === "create") {
            angular.copy(['amount', 'age', 'life', 'ss-payout', 'ss-age',
                'portfolio-type', 'cash-amount', 'portfolios', 'portfolio-confirm',
                'allocation-start', 'cash-amount-end', 'allocation-end', 'review-glide',

                'checkTaxProtection', 'account', 'annual-limit',
                // 'initial-deposit', 'contribution-year',

                // 'auto-deposit',
                // 'strategy',
                // 'auto-deposit-detail', 'auto-deposit-confirm'
            ], $scope.pages);
        } else if ($scope.mod.action === "update") {
            angular.copy(['amount', 'age', 'life', 'ss-payout', 'ss-age',
                'portfolio-type', 'cash-amount', 'portfolios', 'portfolio-confirm',
                'allocation-start', 'cash-amount-end', 'allocation-end', 'review-glide',

                // 'auto-deposit',
                'annual-limit',
                // 'strategy',
                // 'auto-deposit-detail', 'auto-deposit-confirm'
            ], $scope.pages);
        }
        if ($scope.mod.action === "create" || !['simple', 'auto-deposit', 'portfolio-type', 'portfolio-simple-type', 'portfolios', 'strategy', 'confirm'].includes($scope.$stateParams.page)) {
            $scope.goToPage($scope.pages[0]);
        }
    }


    $scope.accountBlurbs = {
        "personal-investment-account": "Since this is a non-retirement account, the returns you accrue are taxable each year, but there are no contribution limits.",
        "traditional-ira": "Deposits may be tax-deductible, but your returns will be taxed upon withdrawal.",
        "roth-ira": "Returns accrue tax free, but your deposits are not tax deductible.",
        "sep-ira": "Deposits may be tax-deductible, but returns will be taxed upon withdrawal. May offer higher deposit limits if you qualify."
    };

    $scope.fundingStrategies = {
        "calculated_waterfall":"Wise Deposits",
        "user_waterfall":"Divide Deposits",
        "user_paused":"Pause Deposits"
    };


    /**
     * Finalizes current page and returns next page
     * @returns {*}
     */
    $scope.mod.extra.getNextPage = function() {
        var page = null;
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);

        switch ($scope.$stateParams.page) {
            case 'ss-payout':
                if ($scope.milestone.metadata.social_security_payout) {
                    page ='ss-age';
                } else {
                    page = 'portfolio-type';
                }
                break;
            case 'initial-deposit':
                page = 'auto-deposit';

                if ($scope.milestone.extra.account_type.includes('roth') || $scope.milestone.extra.account_type.includes('traditional')) {
                    if ($scope.MS.data.retirement.contributionYears.length === 1) {
                        $scope.milestone.extra.contribution_year = $scope.MS.data.retirement.contributionYears[0];
                    } else {
                        page = 'contribution-year';
                    }
                } else {
                    $scope.milestone.extra.contribution_year = null;
                }
                break;
            case 'portfolio-type':
                if ($scope.milestone.extra.portfolio_type === 'cash') {
                    page = 'account';
                }
                break;
            case 'auto-deposit':
                if (
                    //nothing to strategize if no deposits
                        $scope.milestone.auto_deposit.amount === 0
                    ||
                    //shared retirement doesn't get funding strategy
                        $scope.milestone.type_real === 'retirement_shared'
                    ||
                    // //if it's create and personal, go to confirm
                    // ($scope.milestone.account_type && $scope.milestone.extra.account_type.includes('personal'))
                    // ||

                    //if it's create or edit and there's only a personal, go to confirm
                       (    $scope.milestone.accounts.length === 1
                         && $scope.milestone.accounts[0].type.includes('personal')
                       )
                ) {
                    page = 'confirm';
                } else {
                    //has an auto-deposit, is not shared, and is not a personal account
                    if ($scope.mod.action === "create") {
                        page = 'strategy';
                    } else {
                        page = 'annual-limit';
                    }
                }
                break;
            case 'strategy':
                // if ($scope.milestone.metadata.funding_strategy === 'calculated_waterfall') {
                //     page = 'confirm';
                // } else {
                //     //has 2 accounts
                //     page = 'auto-deposit-detail';
                // }
                page = 'confirm';
                break;
            case 'account':
                //on create only
                if ($scope.milestone.extra.account_type.includes('personal')) {
                    // page = 'initial-deposit';
                    page = 'confirm';
                } else {
                    page = 'annual-limit';
                }
                break;
            case 'review-glide':
                if ($scope.mod.action === "update" && $scope.milestone.accounts.length === 1 && $scope.milestone.accounts[0].type.includes('personal')) {
                    page = 'confirm';
                }
                break;
            default:
                break;
        }

        return page;
    };

    /**
     * Pre-check for pages to either initialize them, or defer to a different page
     * Run recursively via the parent $scope.initNextPage method
     * @param page
     * @returns {*}
     */
    $scope.mod.extra.initNextPage = function(page) {
        var newPage = page;

        switch (page) {
            case 'checkTaxProtection':
                    newPage = "account";
                break;
            case 'strategy':
                if (!$scope.milestone.metadata.funding_strategy) {
                    $scope.milestone.metadata.funding_strategy = 'calculated_waterfall';
                }
                break;
        }
        return newPage;
    };

}]);
